export default __webpack_public_path__ + "resources/icons/d210-d427.png";